/* eslint-disable no-shadow */
enum Report {
  GREEN_BOM_REPORT = 'Green BOM Report',
  OBSOLESCENCE_CUSTOM_REPORT = 'Obsolescence Custom Report',
}

export default Report;
